import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePresenter from "./HomePresenter";
import BrowsePresenter from "./BrowsePresenter";
import FavoritesPresenter from "./FavoritesPresenter";
import QuizPresenter from "./QuizPresenter";
import LoginPresenter from "./LoginPresenter";
import NavigationBar from "./Views/NavigationBar";
import ArtModel from "./ArtModel";

export default function Router() {
  return (
    <BrowserRouter>
    <NavigationBar model={ArtModel}/>
      <Routes>
        <Route path="/" element={<HomePresenter model={ArtModel} />} />
        <Route path="/browse" element={<BrowsePresenter model={ArtModel} />} />
        <Route path="/favorites" element={<FavoritesPresenter model={ArtModel} />} />
        <Route path="/quiz" element={<QuizPresenter model={ArtModel} />} />
        <Route path="/login" element={<LoginPresenter model={ArtModel} />} />
      </Routes>
    </BrowserRouter>
  );
}